
export const DashRole = [

  {
    name: "Fire-Fighting",
    roles: [
      {
        id: 9,
        name: "Clients Overview",
      },
      {
        id: 10,
        name: "Total Inspections",
      },
      {
        id: 11,
        name: "Open Tickets",
      },
      {
        id: 12,
        name: "Active Contracts",
      },
      {
        id: 13,
        name: "Inspection Allocation",
      },
      {
        id: 14,
        name: "Inspection Overview",
      },
      {
        id: 15,
        name: "Upcoming Inspections",
      },
      {
        id: 16,
        name: "Open Tasks",
      },
      {
        id: 17,
        name: "Monthly Wise Task Priority",
      },
      {
        id: 18,
        name: "Invoice",
      },
      {
        id: 19,
        name: "Invoice In Due",
      },

      {
        id: 20,
        name: "Open Tickets - Priority",
      },
      {
        id: 21,
        name: "Upcoming Testing & Commissioning",
      },
      {
        id: 22,
        name: "Refilling Status",
      },
        ],
  },
];
